
import logo from '../images/logo.png'


function Footer() {
    return(
             <div>
                 <div class="footerLine"></div>

                     <div class="copyright">
                        <div class="container">
                      <img src={logo} alt="logo" class="img-fluid"/>
      

                      </div>
                      <div className='copyrightText'>
                       <p>copyright 2023.  All rights reserved</p>

                  </div>
 
  

               </div>


             </div>
         



    );
    
}
export default Footer;